import { SWRResponse } from "swr";
import useQuery, {
  UseQueryOptions
} from "rivals/shared/hooks/useQuery/useQuery";
import { Request, Response } from "./types";

export default function useFetchListData(
  requestParams: Request,
  options?: UseQueryOptions
): SWRResponse<Response> {
  let url = "";

  if (requestParams.id) {
    url = `/api/v2/lists/${requestParams.id}`;
  } else {
    const searchParams = new URLSearchParams({
      kind: `${requestParams.kind}`,
      sport: `${requestParams.sport}`,
      year: `${requestParams.year}`
    });
    if (requestParams.version) {
      searchParams.append("version", requestParams.version);
    }
    url = `/api/v2/lists?${searchParams}`;
  }

  return useQuery<Response>(url, options);
}
